import React, { useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Dimmer, Input, Loader } from 'semantic-ui-react'
import { Image } from 'semantic-ui-react'
import { uploadFileToS3 } from '@iheartjane/react-image-list'
import { API_S3_UPLOAD } from '../../consts'

interface OptionalImageProps {
  isEditing: boolean
  onClick: () => void
  onChange: (x: string) => void
  inputName: string
  value: string | null
}

const OptionalImage = (props: OptionalImageProps) => {
  const { inputName, isEditing, onClick, onChange } = props

  const [loading, setLoading] = useState<boolean>(false)

  const uploadFile = async (file: File) => {
    return uploadFileToS3(API_S3_UPLOAD, file, {
      credentials: 'include',
    })
  }

  const reorder = (list: any[], startIndex: number, endIndex: number) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const items = reorder(
      // @ts-ignore
      JSON.parse(props.value),
      result.source.index,
      result.destination.index
    )

    onChange(JSON.stringify(items))
  }

  const img = () =>
    props.value ? (
      <DragDropContext onDragEnd={onDragEnd}>
        <ol>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {JSON.parse(props.value || '[]').map((url: string, index: number) => (
                  <Draggable key={url} draggableId={url} index={index}>
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Image
                          height={200}
                          id={`batch-editor-new-upload-img-${index}`}
                          key={`${url}/${index}`}
                          src={url}
                          alt="Your new upload"
                          rounded
                          style={{ margin: '15px auto' }}
                        />
                      </li>
                    )}
                  </Draggable>
                ))}
              </div>
            )}
          </Droppable>
        </ol>
      </DragDropContext>
    ) : null

  async function onFilesChange(e: any) {
    if (e.target?.files?.length) {
      setLoading(true)
      const promises: any[] = []
      for (let i = 0; i < e.target?.files?.length; i++) {
        const result = uploadFile(e.target.files[i])
        promises.push(result)
      }
      await Promise.all(promises)
        .then((urls) => {
          onChange(JSON.stringify(urls))
        })
        .catch((e) => console.error(e))
      setLoading(false)
    }
  }

  return (
    <div>
      <Dimmer active={loading}>
        <Loader>Loading</Loader>
      </Dimmer>
      <Input
        action={{
          color: 'teal',
          content: !isEditing ? `Edit images` : 'Cancel edit ',
          icon: isEditing ? 'cancel' : 'pencil',
          labelPosition: 'left',
          onClick: () => onClick(),
        }}
        actionPosition="left"
        disabled={!isEditing}
        id="bulk-editor-new-image-input"
        label={{ tag: true, content: inputName }}
        labelPosition="right"
        multiple
        onChange={(e) => onFilesChange(e)}
        size="massive"
        style={{
          marginTop: '30px',
        }}
        type="file"
      />
      <div>
        <i>Use shift+click to select multiple images..</i>
      </div>
      {img()}
    </div>
  )
}

export default OptionalImage
